module.exports = "<p>\n  This page doesn't exist.\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/not-found/not-found.component.html
// module id = ./src/app/components/not-found/not-found.component.html
// module chunks = main